import axiosInstance from "./axiosInstance";

const CookieAPI = {
    getDetailCookie: () => {
        try {
            return axiosInstance.get("/policygroup.json");
        } catch (error) {
            console.error("CookieAPI.getDetailCookie", error);
            return null;
        }
    },
    getDetailCookieEn: () => {
        try {
            return axiosInstance.get("/en/policygroup.json");
        } catch (error) {
            console.error("CookieAPI.getDetailCookie", error);
            return null;
        }
    },

};

export default CookieAPI;
